/**
 * Types et constantes pour les points de rupture responsive
 */

export interface Breakpoints {
  smMobile: number;
  mobile: number;
  mobileWithHeight: number;
  tablet: number;
  desktop: number;
  wide: number;
  'wide-xl': number;
}

/**
 * Valeurs des breakpoints en pixels
 */
export const BREAKPOINTS: Breakpoints = {
  smMobile: 375,
  mobile: 576,
  mobileWithHeight: 576,
  tablet: 768,
  desktop: 992,
  wide: 1200,
  'wide-xl': 1500,
} as const;

